import type {
  UserDataResource,
  UserDataTypeResource,
} from '@/features/iam/api/resources/user-data'
import { mapProviderActivePtinStatusResourceToStatus } from '@/features/iam/providers/provider-mappers'
import type { UserDataProps, UserDataType } from '@/features/iam/users/UserData'
import { match } from '@/utils/pattern-match-util'

export function mapUserDataResourceToProps(
  resource: UserDataResource,
): Partial<UserDataProps> {
  return {
    userPublicId: resource.user_public_id,
    userDataType:
      resource.type && mapUserDataTypeResourceToUserDataType(resource.type),
    ptinStatus:
      resource.active_ptin &&
      mapProviderActivePtinStatusResourceToStatus(resource.active_ptin),
    givenName: resource.given_name,
    familyName: resource.family_name,
    email: resource.email,
    phone: resource.phone,
    workspaceSlugs: resource.workspace_slugs,
    jobCapacity: resource.job_capacity,
  }
}

export function mapUserDataTypeResourceToUserDataType(
  resource: UserDataTypeResource,
): UserDataType {
  return match(resource, {
    USER: 'User',
    PRO: 'Pro',
    ADMIN: 'Admin',
    CALL_AGENT: 'CallAgent',
  })
}

export function mapUserDataTypeToResource(
  type: UserDataType,
): UserDataTypeResource {
  switch (type) {
    case 'User':
      return 'USER'
    case 'Pro':
      return 'PRO'
    case 'Admin':
      return 'ADMIN'
    case 'CallAgent':
      return 'CALL_AGENT'
  }
}
